import { apiUrl2, apiUrl } from '../../../settings'

export const ListAllAgentCommissions = () => {
  return apiUrl2 + '/getAllAgentCommissions'
}
export const reCalculateAgentCountryBalanceUrl = () => {
  return apiUrl + '/api/reCalculateAgentBalance'
}
